import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAllExamsStart, setCurrentExam } from "../../redux/exam/reducer";
import {
  selectExamLoading,
  selectCurrentExam,
  selectExamList,
} from "../../redux/exam/selectors";
import usePaginationWrapper from "../../hooks/general/usePaginationWrapper";
const useExamsGet = ({ examGroupId }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectExamLoading);
  const exams = useSelector(selectExamList);

  const currentExam = useSelector(selectCurrentExam);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 10 });

  const fetchExams = useCallback(() => {
    dispatch(
      getAllExamsStart({
        examGroupId,
        name: debouncedSearchText,
        size: limit,
        page: (page - 1) ,
      })
    );
  }, [dispatch, examGroupId, page, limit, debouncedSearchText]);

  const setCurrent = (exam) => {
    dispatch(setCurrentExam(exam));
  };

  useEffect(() => {
    if (exams) {
      setPageable({
        total_elements: exams?.count,
        total_pages: exams?.pages,
        number_of_elements: exams?.items?.length,
      });
    }
  }, [exams, setPageable, fetch, debouncedSearchText]);

  useEffect(() => {
    fetchExams();
  }, [fetchExams, fetch]);

  return {
    exams,
    loadingExams: isLoading,
    currentExam,
    setCurrent,
    refetch,
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  };
};

export default useExamsGet;
